export enum AnnotationPriorities {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
}
